import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
  const { isAuthenticated, loading } = useAuth();
  const permissions = useSelector((state) => state.auth.permissions);

  // 1. Handle Loading State First
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // 2. If NOT authenticated, immediately kick them out to /auth
  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  // 3. Check Permissions
  const hasAccess = requiredPermissions.every((perm) =>
    permissions?.includes(perm),
  );

  if (requiredPermissions.length > 0 && !hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  // 4. Render children if all checks pass
  return children;
};

export const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
